// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__2rwPr","ctaButton":"Cta_ctaButton__3BQC7 Cta_cta__2rwPr","ctaLink":"Cta_ctaLink__1OhxW Cta_cta__2rwPr","ctaPill":"Cta_ctaPill__3x50v"};